import { filter, isEmpty, pick, split } from 'lodash'

const transformToUpdateDietSimpleDetailsArgs = data => ({
  ...pick(data, [
    'description',
    'isAvailableForDishCategorization',
    'position',
    'isExcludedFromSearch',
    'isPopular',
  ]),
  synonyms: filter(split(data.synonyms, '\n'), synonym => !isEmpty(synonym)),
})

export default transformToUpdateDietSimpleDetailsArgs
